<template>
    <div class="paymentForm warn-on-exit">
        <div class="form-group">
            <label class="control-label">Company</label>
            <company name="Payment" :data="model.company" v-model="model.company" :min-length="0"></company>
        </div>

        <div class="form-group">
            <label class="control-label">Invoice</label>
            <invoice-list :company="model.company" name="payment" v-model="model.invoice"></invoice-list>
        </div>

        <div class="form-group">
            <txt label="Amount" v-model="model.amount"></txt>
        </div>

        <list label="Payment Type" v-model="model.payment_type_id" :usekey="1"
              :list="{ 1: 'eWay Payment', 2: 'Bank Transfer', 3: 'Cash', 4: 'Debit', 5: 'ACH', 6: 'MasterCard', 7: 'American Express', 8: 'Discover Card', 9: 'Diners Card', 10: 'EuroCard', 11: 'Nova', 12: 'Credit Card Other', 13: 'PayPal', 14: 'Google Wallet', 15: 'Check', 17: 'Stripe Payment', 19: 'Credit', 20: 'Refund' }" ></list>

        <div class="form-group">
            <label :for="model.public_id + 'payment_date'"  class="control-label">Payment Date</label>
            <datepicker input-class="form-control" format="dd MMM yyyy" :id="model.public_id + 'payment_date'" type="text" v-model="model.payment_date"></datepicker>
        </div>

        <div class="form-group">
            <txt label="transaction_reference" v-model="model.transaction_reference"></txt>
        </div>

        <div class="buttons">
            <button class="btn btn-success btn-sm" @click.prevent="store">Save <i class="icon icon-save"></i></button>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        components: {
            Datepicker,
            'invoice-list': require('../../components/invoice-list.vue').default,
            'list': require('../../components/form/list.vue').default,
        },
        props: {
            name: { default: '' },
            data: { default: false }
        },
        data() {
            return {
                model: {
                    public_id: 0,
                    company: { id: 0, name: ''},
                    invoice: { id: 0 , name: '' },
                    amount: '',
                    payment_date: '',
                    payment_type_id: 2,
                    transaction_reference: ''
                }
            }
        },
        created() {
            if (typeof this.data['invoice'] !== 'undefined') {
                this.model.invoice = this.data.invoice;
            }
            if (typeof this.data['company'] !== 'undefined') {
                this.model.company = this.data.company;
            }
            this.$eventHub.$on('paymentSubmit', this.store);
            this.$eventHub.$on('setPayment', this.setPayment);
        },
        methods: {
            toggleDatePicker(event) {
                this.$nextTick(function () { // Runs after content is updated
                    toggleDatePicker(event.currentTarget);
                });
            },
            store (){
                this.$store('/api/payment/save', this);
            },
            setPayment(data) {
                this.model = this.$setData(data, this.model);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('paymentSubmit', this.store);
            this.$eventHub.$off('setPayment', this.setPayment);
        }
    }
</script>
<style>
    .datepicker .calendar {
        color: #fff;
        background: #333;
        bottom:0;
        left: 120px;
    }
</style>
